import { CmsConfirmDialog } from "../CmsConfirmDialog/CmsConfirmDialog";

type UnsavedChangesModalProps = {
  onDiscard: () => void;
  onCancel: () => void;
};

/**
 * The leave-without-saving prompt. Holds nothing but its own wording — the dialog itself is
 * `CmsConfirmDialog`, shared with the edition status change prompt so the two look alike.
 *
 * `danger`: confirming here loses the user's unsaved work.
 */
export function UnsavedChangesModal({ onDiscard, onCancel }: UnsavedChangesModalProps) {
  return (
    <CmsConfirmDialog
      title="Unsaved changes"
      message="You have unsaved changes that will be lost if you leave this page."
      confirmLabel="Leave without saving"
      cancelLabel="Stay on page"
      tone="danger"
      onConfirm={onDiscard}
      onCancel={onCancel}
    />
  );
}
